import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Stack, Typography, CtaButton } from '@moonsifttech/design-system';

import TopMenu from 'src/mvp22/menu-components/TopMenu';
import BottomBar from 'src/mvp22/menu-components/BottomBar';
import R from 'src/routes';
import { CreatorLandingProps } from './CreatorLanding.types';

const UnstyledCreatorLanding: React.FC<CreatorLandingProps> = ({
  className,
  style,
}) => {
  const history = useHistory();
  const handleApply = useCallback(() => {
    history.push(R.CREATOR_APPLICATION_ONE);
  }, [history]);

  return (
    <div className={className} style={style}>
      <TopMenu className="CreatorLanding-topMenu" />
      <Stack
        className="CreatorLanding-container"
        direction="column"
        justifyContent="space-between"
      >
        <Stack
          className="CreatorLanding-innerContainer"
          direction="column"
          alignItems="center"
        >
          <Typography
            className="CreatorLanding-heading"
            variant="editorial.sb34"
            component="h1"
            color="common.white"
            align="center"
          >
            You've discovered a secret new Moonsift project.
          </Typography>
          <Typography
            className="CreatorLanding-subheading"
            variant="primary.r26"
            component="p"
            color="common.white"
            align="center"
          >
            A new way to monetise your passion and earn from 30,000+ of the
            world's most coveted brands.
          </Typography>
          <CtaButton
            className="CreatorLanding-applyButton"
            variant="primary-white"
            onClick={handleApply}
          >
            Apply for early access
          </CtaButton>
        </Stack>
        <BottomBar />
      </Stack>
    </div>
  );
};

export const CreatorLanding = styled(UnstyledCreatorLanding)`
  .CreatorLanding-topMenu {
    height: 56px;
  }

  .CreatorLanding-container {
    min-height: calc(100vh - 56px);
    background: var(--common-black);
  }

  .CreatorLanding-innerContainer {
    padding: 100px 20px 0;
    max-width: 640px;
    margin: 0 auto;
  }

  .CreatorLanding-heading {
    margin-bottom: 24px;
  }

  .CreatorLanding-subheading {
    margin-bottom: 32px;
  }

  .CreatorLanding-applyButton {
    margin-bottom: 20px;
  }

  ${({ theme }) => theme.fns.getMediaQuery({ minWidth: 'md' })} {
    .CreatorLanding-innerContainer {
      padding-top: 120px;
    }

    .CreatorLanding-heading {
      margin-bottom: 22px;

      ${({ theme }) => theme.fns.getTypographyStyles('editorial.r46')}
    }
  }
`;
